import { makeStyles } from '@mui/styles';
const expressionsOfInterestStyles = makeStyles(({ palette }) => ({
    sectionTitle: {
        fontWeight: 'bold',
        color: palette.common.black,
        display: 'inline-block',
        margin: '10px 0',
    },
    content: {
        padding: '10px 0',
        borderBottom: `1px solid ${palette.text.disabled}`,
    },
}), { name: 'Common_ExpressionsOfInterest' });
export default expressionsOfInterestStyles;
//# sourceMappingURL=expressionsOfInterest.styles.js.map